import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

export default function About() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>About Go With Me Buddy</h1>
          <p>Connecting travelers worldwide for unforgettable adventures</p>
        </div>
      </div>

      <div className="about-container">
        <section className="about-section">
          <h2>Our Story</h2>
          <p>
            Go With Me Buddy was born from a simple idea: solo travel shouldn't mean traveling alone. 
            We believe that the best travel experiences come from shared adventures, meaningful connections, 
            and exploring the world together.
          </p>
          <p>
            Founded in 2025, our platform connects like-minded travelers who share a passion for exploration 
            and discovery. Whether you're looking for a travel companion for your next adventure or want to 
            join a group tour with a trusted agency, we're here to make it happen.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Mission</h2>
          <p>
            To create a safe, vibrant community where travelers can connect, share experiences, and embark 
            on life-changing journeys together. We're committed to making travel more accessible, enjoyable, 
            and meaningful for everyone.
          </p>
        </section>

        <section className="about-section">
          <h2>What We Offer</h2>
          <div className="features-grid">
            <div className="feature-box">
              <div className="feature-icon">🤝</div>
              <h3>Partner Matching</h3>
              <p>Find travel companions who share your interests and destinations</p>
            </div>
            <div className="feature-box">
              <div className="feature-icon">🏢</div>
              <h3>Verified Agencies</h3>
              <p>Connect with trusted travel agencies for group tours</p>
            </div>
            <div className="feature-box">
              <div className="feature-icon">⭐</div>
              <h3>Ratings & Reviews</h3>
              <p>Make informed decisions based on community feedback</p>
            </div>
            <div className="feature-box">
              <div className="feature-icon">🔒</div>
              <h3>Safe & Secure</h3>
              <p>Travel with confidence using our verified platform</p>
            </div>
          </div>
        </section>

        <section className="about-section">
          <h2>Our Values</h2>
          <ul className="values-list">
            <li><strong>Safety First:</strong> We prioritize the security and well-being of our community</li>
            <li><strong>Authenticity:</strong> We encourage genuine connections and honest reviews</li>
            <li><strong>Inclusivity:</strong> We welcome travelers from all backgrounds and experiences</li>
            <li><strong>Sustainability:</strong> We promote responsible and eco-conscious travel</li>
          </ul>
        </section>

        <section className="cta-section">
          <h2>Join Our Community</h2>
          <p>Ready to start your next adventure with Go With Me Buddy?</p>
          <div className="cta-buttons">
            <Link to="/register" className="btn-primary">Get Started</Link>
            <Link to="/contact" className="btn-secondary">Contact Us</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
